import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList, teamLeaderList, viewDataUserList }) {
    return InboxMembersAPI.update({
      inboxId,
      agentList,
      teamLeaderList,
      viewDataUserList,
    });
  },
};

export default {
  namespaced: true,
  actions,
};
